/**
 * /.../create language tabs handler
 *
 * Created by sasik on 10/22/15.
 */


$('.nav-tabs a').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
});

$(".process-hide-by-type").each(function(){
    var $self=$(this);
    //watchers
    var workAround=function() {
        var cal = $self.find("input[name=type]:checked").val();
        if(cal!=="simple" && cal!=="html")
            return;
        if (cal === "simple")
        {
            $self.find(".only-on-simple").show();
            $self.find(".only-on-html").hide();
        }else{
            $self.find(".only-on-simple").hide();
            $self.find(".only-on-html").show();
        }
    };
    $self.find("input[name=type]").on("change",workAround);
    workAround();

});